import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MarketingNav from "./MarketingNav";
import Footer from "./Footer";

export default function MarketingLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <MarketingNav />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
